import { ContentCardModel } from "~/models/ContentCard";
import { ContentCardsModel } from "~/models/ContentCards";

export const useHighlights = () => {
  const imageUrl = import.meta.env.VITE_IMAGE_URL;
  const highlightsContent = ref(new ContentCardsModel());
  const isLoading = ref(true);

  const fetchHighlights = async () => {
    try {
      const resHighlights = await useFetchGet<ResponseHighlights>(
        "/contents/highlights",
      );

      if (resHighlights?.length > 0) {
        addContentCards(resHighlights);
        isLoading.value = false;
      }
    } catch (_) {
      isLoading.value = true;
    }
  };

  const addContentCards = (highlights: ResponseHighlights) => {
    highlights.forEach((item) => {
      highlightsContent.value.addContent(
        new ContentCardModel(
          item.id,
          `${imageUrl}${item.banner_image}`,
          item.title_th,
        ),
      );
    });
  };

  return {
    fetchHighlights,
    highlightsContent,
    isLoading,
  };
};
